import { render } from "./saturation.vue?vue&type=template&id=2b83717a&scoped=true"
import script from "./saturation.vue?vue&type=script&lang=js"
export * from "./saturation.vue?vue&type=script&lang=js"

import "./saturation.vue?vue&type=style&index=0&id=2b83717a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\86134\\Desktop\\Web\\Item\\来画设计\\laiiva-web\\packages\\QColor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b83717a"]])

export default __exports__